import { Component, Injector, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserLogin } from '../user-login/user-login';
import { UserSignup } from '../user-signup/user-signup';
import { Util } from '../../app/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-user-forgotpassword',
  templateUrl: 'user-forgotpassword.html',
})
export class UserForgotpassword extends Util {
  email: any;

  username: string = '';
  private captchaPassed: boolean = false;
  private captchaResponse: string;
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, private zone: NgZone) {
    super(injector, null);
    this.translate.get(['recuperapassword.RECUPEROPASS', 'recuperapassword.CONTROLLACASELLA']).subscribe(v => {
      // console.log(v);
    })
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UserForgotpassword');
  }

  dashboardPage() { this.navCtrl.push(Dashboard); }
  loginPage() { this.navCtrl.push(UserLogin); }
  signupPage() { this.navCtrl.push(UserSignup); }
  forgotpass() {
    if (this.username != '') {//this.captchaPassed &&
      this.PostRequest('forgot_password', this.username, {}, true, true).then((data) => {
        this.translate.get(['recuperapassword.RECUPEROPASS', 'recuperapassword.CONTROLLACASELLA']).subscribe(v => {
          this.showBasicAlert(v['recuperapassword.RECUPEROPASS'], v['recuperapassword.CONTROLLACASELLA']);
          this.navCtrl.push(UserLogin);
        })
      }).catch(err => {
        console.error(err);
        // this.showBasicAlert('Error',err.errors);
      });
    }
    else {
      this.translate.get(['ERRORE', 'recuperapassword.ERROREINS','recuperapassword.ERROREDIC']).subscribe(v => {
      if (this.username == '')
        this.showBasicAlert(v['ERRORE'], v['recuperapassword.ERROREINS']);
      else
        this.showBasicAlert(v['ERRORE'], v['recuperapassword.ERROREDIC']);
      });
    }
  }
  captchaResolved(response: string): void {

    this.zone.run(() => {
      this.captchaPassed = true;
      this.captchaResponse = response;
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/user-forgotpassword/user-forgotpassword.ts